export default {
	init() {

		var container = document.querySelectorAll('.rentalCars');

		if( container.length != 0 ) {

			var box = document.querySelector('.rentalCars');

			var titles = box.querySelectorAll('.cars__title button');

			var descriptions = box.querySelectorAll('.cars__description .description__basic');

			var images = box.querySelectorAll('.rentalCars__images .images__carThumbnail');
			

			var timer = null;
			var counter = 1;
			var length = titles.length;

			function Loop() {

				timer = window.setInterval( 

					function() { 

						if( counter >= length ) {

							counter = 0;

						}

						titles.forEach( function( title , index ) {

							if( counter == index ) {

								title.classList.add('active');

							} else {

								title.classList.remove('active');

							}

						});

						descriptions.forEach( function( desc, index ) {

							if( counter == index ) {

								desc.classList.add('active');

							} else {

								desc.classList.remove('active');

							}

						});

						images.forEach( function( image, index ) {

							if( counter == index ) {

								image.classList.add('active');

							} else {

								image.classList.remove('active');

							}

						});

						counter +=1;

					}, 4000
				);

			};

			function startLoop(time) {

				setTimeout( 
					Loop()
					,time 
				)

			};		

			function stopLoop() {

				window.clearInterval(timer);
				timer = null;

			};

			titles.forEach( function(title, indexT) {

				title.addEventListener('click',function(){

					stopLoop();

					counter = indexT;

					titles.forEach( function(title2, indexT2){

						if( indexT == indexT2 ) {

							title.classList.add('active');

						} else {

							title2.classList.remove('active');

						}

					});

					descriptions.forEach( function(desc, indexD){

						if( indexT == indexD ) {

							desc.classList.add('active');

						} else {

							desc.classList.remove('active');

						}

					});

					images.forEach( function(image, indexI){

						if( indexT == indexI ) {

							image.classList.add('active');

						} else {

							image.classList.remove('active');

						}
 
					});

					startLoop(12000);

				});

			});

			startLoop(4000);
				

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
